import React, { useState } from "react";
import { Grid, Typography, Modal, ThemeProvider } from "@mui/material";
import { basicTheme } from "../../themes/customTheme";
// import { makeStyles } from "@mui/material/styles";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import FormCard from "../formManagement/formCard";

// const useStyles = makeStyles(() => ({
//   closeBtnStyle: {
//     zoom: "2.2",
//     alignItems: "right",
//     color: "#444444",
//     cursor: "pointer",
//     "&:hover": { opacity: 0.7 },
//     maxHeight: "1rem",
//     maxWidth: "1rem",
//   },
// }));
const subGridStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "1.5rem",
  width: "65%",
  maxHeight: "80%",
  overflow: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  paddingLeft: 5,
  paddingTop: 2,
};

export default function FormListModal({
  openListModal,
  handleClose = () => {},
  forms,
}) {
  // const classes = useStyles();
  const handleCloseByClearIcon = () => {
    handleClose();
  };

  const [selectedFormIndex, setSelectedFormIndex] = useState(0);
  return (
    <Modal open={openListModal}>
      <Grid container sx={subGridStyle}>
        <ThemeProvider theme={basicTheme}>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", flexDirection: "row-reverse" }}
          >
            <Grid
              item
              xs={1}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <CloseRoundedIcon
                // className={classes.closeBtnStyle}
                onClick={handleCloseByClearIcon}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <div
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
                paddingBottom: "10px",
              }}
            >
              {forms != null &&
                forms.map((item, index) => (
                  <Typography
                    variant="body1"
                    sx={{
                      display: "inline-block",
                      height: "38px",
                      padding: "5px 14px 5px 14px",
                      borderRadius: "10px",
                      marginRight: "8px",
                      backgroundColor:
                        selectedFormIndex === index ? "#2D6A4F" : "#F5F5F5",
                      color:
                        selectedFormIndex === index ? "#FFFFFF" : "#ACADAD",
                      cursor: "pointer",
                      textAlign: "center",
                      whiteSpace: "normal",
                    }}
                    key={index}
                    onClick={() => {
                      setSelectedFormIndex(index); // Update selectedFormIndex directly
                    }}
                  >
                    {item.name}
                  </Typography>
                ))}
            </div>
          </Grid>

          <Grid item xs={12} marginTop={1.5}>
            <Typography
              variant="h5"
              sx={{ color: "#78828C", fontWeight: "400" }}
            >
              Questions
            </Typography>
          </Grid>
          {selectedFormIndex !== null && (
            <>
              {forms[selectedFormIndex].questions != null &&
                forms[selectedFormIndex].questions.map((item, index) => (
                  <FormCard
                    index={index}
                    view={true}
                    question={item}
                    key={`${selectedFormIndex}-${index}`}
                  />
                ))}
            </>
          )}
        </ThemeProvider>
      </Grid>
    </Modal>
  );
}
